// extracted by mini-css-extract-plugin
module.exports = {"BooleanFeature":"vs_a bhe_b"};